/**
 * UEFA Champions League - competition rule, every season.
 *
 * Identity: API-Football league.id = 2.
 */

import { UEFA_LEAGUE_PHASE_BRACKET } from '../brackets/uefaLeaguePhaseBracket';
import type { CompetitionRule } from '../types';

const rule: CompetitionRule = {
  leagueCode: '2',
  tieBracket: UEFA_LEAGUE_PHASE_BRACKET,
};

export default rule;
